<template>
  <tbody>
    <tr :class="isSelected ? 'selectedClusterTableRow' : ''" @click="emitClick()">
      <td style="max-width: 10rem;">{{ Title }}</td>
      <td>
        <span
          v-if="Waves[3] && Waves[3].Result != null"
          v-b-tooltip.hover
          :title="Waves[3].Name"
        >
          {{ Waves[3].Result }}{{valueSymbol}}
          <TrendIcon
            v-if="Waves[4]"
            :Difference="Waves[3].Result - Waves[4].Result"
          />
        </span>
        <span v-else>-</span>
      </td>
      <td>
        <span
          v-if="Waves[2] && Waves[2].Result != null"
          v-b-tooltip.hover
          :title="Waves[2].Name"
        >
          {{ Waves[2].Result }}{{valueSymbol}}
          <TrendIcon 
            v-if="Waves[3]"
            :Difference="Waves[2].Result - Waves[3].Result" 
          />
        </span>
        <span v-else>-</span>
      </td>
      <td>
        <span
          v-if="Waves[1] && Waves[1].Result != null"
          v-b-tooltip.hover
          :title="Waves[1].Name"
        >
          {{ Waves[1].Result }}{{valueSymbol}}
          <TrendIcon 
            v-if="Waves[2]"
            :Difference="Waves[1].Result - Waves[2].Result" 
          />
        </span>
        <span v-else>-</span>
      </td>
      <td>
        <span
          class="border-left pl-3"
          v-b-tooltip.hover
          :title="Waves[0].Name"
        >
          <b>{{ Waves[0].Result }}{{valueSymbol}}</b>
          <TrendIcon 
            v-if="Waves[1]"
            :Difference="Waves[0].Result - Waves[1].Result" 
          />
        </span>
      </td>
      <td>
        <AccomplishmentIcon :is-accomplished="(Waves[0].Result == 100)" />
      </td>
      <!-- <td>
        <font-awesome-icon
          v-if="Waves[0].Hints"
          :icon="['fas', showDetail ? 'chevron-down' : 'chevron-right']"
        ></font-awesome-icon>
      </td> -->
    </tr>

    <tr v-if="Waves[0].Hints && showDetail">
      <td colspan="7" class="bg-light">
        <div class="p-3">
          <h5>{{ Title }}</h5>
          <p v-html="Waves[0].Hints"></p>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import TrendIcon from "@/components/Shared/TrendIcon";
import AccomplishmentIcon from "@/components/Shared/AccomplishmentIcon";

export default {
  name: "ClusterTableRow",
  components: {
    TrendIcon,
    AccomplishmentIcon,
  },
  data: function () {
    return {
      showDetail: false,
    };
  },
  props: {
    Title: String,
    Waves: Array,
		valueSymbol: String,
    isSelected: { type: Boolean, default: false }
  },
  methods: {
    emitClick() {
      this.$emit("click", this.Title);
    }
  }
};
</script>

<style scoped>
td span {
  text-align: right;
  display: inline-block;
  min-width: 4rem;
}
.selectedClusterTableRow {
  background-color: rgba(128, 128, 128, 0.4);
}
</style>